import { injectSignatureHeaders } from './base/signature.js';
import paramManager from '@/helper/param.manager';
import { SIGNATURE_REQUIRED_URLS } from '@/helper/constants';
import { SignatureLog } from '@/helper/log/business/signature.log';

/**
 * process signature headers
 * @param url request url
 */
export async function processSignature(url: string) {
  try {
    const secret = paramManager.getSignatureSecret();
    const serverTimeOffset = paramManager.getServerTimeOffset();

    if (!secret) {
      return {};
    }

    const result = await injectSignatureHeaders(
      url,
      secret,
      serverTimeOffset,
      SIGNATURE_REQUIRED_URLS,
    );

    return result;
  } catch (error) {
    // record failure log
    SignatureLog.logSignatureGenerationFailure(url, error);

    // return empty object to ensure normal request
    return {};
  }
}
